import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
import { getAuthCredentials } from "../../../utils/auth";

const ls = new SecureLS({ encodingType: "aes" });

const TransactionSalesModal = ({ open, onClose }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { token } = getAuthCredentials();

  const handleGenerate = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/reports/transaction-sales`,
        {
          startDate,
          endDate,
        },
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const storeName = ls.get("user")?.storeName || "Store";
      const filename = `${storeName.replace(
        /\s+/g,
        "_"
      )}_Transaction_Sales_Report_${startDate}_to_${endDate}.xlsx`;

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      Swal.fire(
        "Success",
        "Transaction Sales Report generated successfully",
        "success"
      );
      onClose();
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to generate report",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Generate Transaction Sales Report</DialogTitle>
      <DialogContent>
        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          fullWidth
          sx={{ my: 2 }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="End Date"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleGenerate}
          variant="contained"
          color="primary"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Generate"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransactionSalesModal;
